var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMirino(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mirino") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sparkasse-UI-library",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Organism-/-Form-/-Carousel-/-Multi-/-Alias",
    transform: "translate(-72.000000, -40.000000)",
    fill: "#DF0025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Organism-/-Form-/-Carousel-/-First"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Carousel-conto-/-Active",
    transform: "translate(72.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Mirino",
    points: "0 0 16 0 16 2.02599526 2 2.03409935 2 16 0 16"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirino);
export default __webpack_public_path__ + "static/media/mirino.c49ba4f7973f41b844e6dea9f7cabbc9.svg";
export { ForwardRef as ReactComponent };